// Most specific first: adapters disagree on which key carries the slug.
export const SKILL_NAME_KEYS = [
  "skill",
  "skill_name",
  "skillName",
  "name",
  "command",
];

export const SKILL_FILE = "skill.md";
